import React, { useState, useEffect, useCallback } from "react";
import { Box } from "@mui/material";
import useClampedScroll from "../hooks/useClampedScroll";

const SKY_SRC = "/potion/bg_sky.jpg";
const BUILDING_SRC = "/potion/bg_building.png";

export default function PotionBackground() {
  const [naturalSize, setNaturalSize] = useState(null);
  const [buildingRenderedHeight, setBuildingRenderedHeight] = useState(0);

  const updateRenderedHeight = useCallback((size) => {
    if (!size) return;
    setBuildingRenderedHeight(
      (window.innerWidth / size.width) * size.height
    );
  }, []);

  const handleBuildingLoad = useCallback((e) => {
    const { naturalWidth, naturalHeight } = e.target;
    const size = { width: naturalWidth, height: naturalHeight };
    setNaturalSize(size);
    updateRenderedHeight(size);
  }, [updateRenderedHeight]);

  useEffect(() => {
    const onResize = () => updateRenderedHeight(naturalSize);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [naturalSize, updateRenderedHeight]);

  const { ref: buildingRef } = useClampedScroll(buildingRenderedHeight);

  return (
    <>
      {/* Layer 1: Sky — fixed, top-aligned, covers viewport */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          zIndex: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <Box
          component="img"
          src={SKY_SRC}
          alt=""
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top",
            display: "block",
          }}
        />
      </Box>

      {/* Layer 2: Building — fixed + translateY clamped */}
      <Box
        component="img"
        ref={buildingRef}
        src={BUILDING_SRC}
        alt=""
        onLoad={handleBuildingLoad}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "auto",
          zIndex: 1,
          pointerEvents: "none",
          willChange: "transform",
        }}
      />
    </>
  );
}
